import React from "react"
import { useTranslation } from "react-i18next"

import { Modal } from "components"
import Button from "./Button"
import classes from "./ConfirmationModal.module.scss"
import clsx from "clsx"

const ConfirmationModal = props => {
  const {
    show,
    title,
    onHide,
    onExited,
    onConfirm,
    loading
  } = props

  const [t, i18n] = useTranslation()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      onExited={onExited}

    >
      <div className={classes["container"]}>
        <h4 className={classes["title"]}>
          {title}
        </h4>
        <div className={classes["footer"]}>
          <Button
            color="danger"
            disabled={loading}
            onClick={onHide}
            className={clsx(classes["yes"], isLtr && classes["yes-ltr"])}
          >
            {t("خیر")}
          </Button>
          <Button
            color="success"
            loading={loading}
            onClick={onConfirm}
          >
            {t("بله")}
          </Button>
        </div>
      </div>
    </Modal >
  )
}

export default ConfirmationModal